// third-party
import { combineReducers } from 'redux';

// project import
import menuReducer from './menu';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
  menu: menuReducer
});

export default reducers;